import React, { CSSProperties, ReactNode } from 'react'
import ModalDefault from 'react-modal'

import s from './styles.module.scss'

import { Icon } from '..'
import { Divider } from '../divider/Divider'
import { Scrollbars } from '../../layout'
import { Loader } from '../../molecules'

export interface SimpleModalProps {
  errorMessage?: string
  name: string
  hasError: boolean
  isLoading: boolean
  isOpen: boolean
  loader?: ReactNode
  onClose: (() => void) | null
  content: {
    header: ReactNode
    body: ReactNode
    footer: ReactNode | null
  }
  style?: Pick<CSSProperties, 'height' | 'width'>
}

export const SimpleModal = ({
  errorMessage,
  name,
  hasError,
  isLoading,
  isOpen,
  loader,
  onClose,
  content: { footer, header, body },
  style,
}: SimpleModalProps) => {
  return (
    <ModalDefault
      id={`simple-modal-${name}`}
      isOpen={isOpen}
      {...(onClose ? { onRequestClose: onClose } : {})}
      overlayClassName={s.overlay}
      className={s.modal}
      style={{
        content: {
          height: '95%',
          width: '70%',
          pointerEvents: 'auto',
          ...style,
        },
      }}
      shouldCloseOnOverlayClick={true}
      shouldFocusAfterRender={false}
      ariaHideApp={false}
    >
      <Scrollbars>
        <div className={s.content}>
          <div className={s.header}>
            <div style={{ width: '100%' }}>{header}</div>

            {onClose ? (
              <button onClick={onClose}>
                <Icon name='cross-without-circle' size={14} color='#000000' />
              </button>
            ) : null}
          </div>

          {isLoading ? (
            (loader ?? <Loader />)
          ) : hasError ? (
            <div className={s.error}>
              <p>Une erreur s&apos;est produite...</p>

              {errorMessage ? <div>{errorMessage}</div> : null}
            </div>
          ) : (
            <>
              <Divider />

              <div className={s.body}>{body}</div>

              {footer ? (
                <>
                  <Divider />

                  <div className={s.footer}>{footer}</div>
                </>
              ) : null}
            </>
          )}
        </div>
      </Scrollbars>
    </ModalDefault>
  )
}
